import { render, staticRenderFns } from "./quanshi.vue?vue&type=template&id=4775d959&scoped=true&"
import script from "./quanshi.vue?vue&type=script&lang=js&"
export * from "./quanshi.vue?vue&type=script&lang=js&"
import style0 from "./quanshi.vue?vue&type=style&index=0&id=4775d959&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4775d959",
  null
  
)

export default component.exports